export default __webpack_public_path__ + "static/media/drzewa_3.ba33c443.svg";